import { render } from "./demandFullModel.vue?vue&type=template&id=5602a810"
import script from "./demandFullModel.vue?vue&type=script&lang=js"
export * from "./demandFullModel.vue?vue&type=script&lang=js"

import "./demandFullModel.vue?vue&type=style&index=0&id=5602a810&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__